<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="'全部 ' + '(' + pageConfig.total + ')'"
        name="all"
      ></el-tab-pane>
      <el-tab-pane
        :label="'待收货 ' + '(' + allKinds.beReceivedCount + ')'"
        name="10"
      ></el-tab-pane>
      <el-tab-pane
        :label="'收货完成 ' + '(' + allKinds.goodsReceivedCount + ')'"
        name="20"
      ></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->

    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:WarehouseId>
        <el-select
          multiple
          filterable
          v-model="filters.WarehouseId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:OrgId>
        <el-select
          multiple
          filterable
          v-model="filters.OrgId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:InventoryStatus>
        <el-select
          multiple
          filterable
          v-model="filters.InventoryStatus"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in inventoryStatusList"
            :label="item.statusText"
            :value="item.statusValue"
            :key="item.statusValue"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:SignForStatus>
        <el-select
          multiple
          filterable
          v-model="filters.SignForStatus"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in signForStatusList"
            :label="item.statusText"
            :value="item.statusValue"
            :key="item.statusValue"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:tdate>
        <el-select
          class="dateSelect"
          v-model="filters.DateType"
          placeholder="请选择"
        >
          <el-option
            v-for="item in dateTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template slot-scope="scope" slot="signForNumber">
        <hoverCopy>
          <el-link
            slot="referenceChild"
            :underline="false"
            type="primary"
            @click.native="showReceiptNo(scope.row)"
            >{{ scope.row.signForNumber }}
          </el-link>
        </hoverCopy>
      </template>
      <template slot-scope="scope" slot="file">
        <div>
          <span>照片:</span>
          <span v-if="scope.row.isSignFor > 0">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.tfSignForID, 34)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="
                handleImages(scope.row.tfSignForID, scope.row.signForNumber, 34)
              "
            >
              下载
            </el-link>
          </span>
        </div>
      </template>
      <template slot-scope="scope" slot="abnorInfo">
        <div v-if="scope.row.isAbnormal">
          <span>备注:{{ scope.row.abnormalRemark }}</span>
          <br />
          <span>照片:</span>
          <span>
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.tfSignForID, 44)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="
                handleImages(scope.row.tfSignForID, scope.row.signForNumber, 44)
              "
            >
              下载
            </el-link>
          </span>
        </div>
      </template>
      <template slot-scope="scope" slot="distributeGoodsMark">
        <div>
          <span v-if="scope.row.fileUrlF != '' && scope.row.fileUrlF != null">
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="DownloadAttachBtn(scope.row)"
            >
              下载
            </el-link>
          </span>
          <br />
        </div>
      </template>
      <template slot-scope="scope" slot="palletMark">
        <div>
          <span v-if="scope.row.fileUrl != '' && scope.row.fileUrl != null">
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="DownloadProductSKUAttachBtn(scope.row)"
            >
              下载
            </el-link>
          </span>
          <br />
        </div>
      </template>
      <template slot-scope="scope" slot="resynchronize">
        <div>
          <el-button
            style="margin-left: 10px"
            :underline="false"
            type="text"
            size="small"
            @click.native="getbusinessLoglist(scope.row)"
          >
            日志
          </el-button>
          <br />
        </div>
      </template>
      <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="operatorInfo">
          <span>收货:{{ scope.row.completeReceiptUser }}</span>
          <br />
          <span>上架:{{ scope.row.completePutOnUser }}</span>
      </template>
    </TwTable>

    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{
        businessType: 34,
        businessCode: currentRow.signForNumber,
      }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>

    <ReceiptNoDalog ref="ReceiptNoRef"></ReceiptNoDalog>
    <createQualityList
      ref="createQualityListRef"
      :sourceType="20"
      @searchTable="initTable"
    />

    <!-- 预览图片 -->
    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>
  </div>
</template>

<script>
import {
  getTFSignForTaskAsync,
  exportSignForTaskAsyncOut,
  getSignForTaskBasis,
} from "@/api/transfer/tfSignFor/signInManage.js";
import {
  getUploadFileInfoBySourceID,
  getUploadFileReviewImagesFileOut,
  getOperatorInfo,
} from "@/api/api.js";

import { getButtonList } from "../../../promissionRouter";
import TwTable from "../../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../../components/TwTable/components/logDialog";
import ReceiptNoDalog from "./ReceiptNoDalog.vue";
import hoverCopy from "../../../components/hoverCopy.vue";
import createQualityList from "../../QCCheck/components/createQualityList.vue";
export default {
  components: {
    LogDialog,
    TwTable,
    ReceiptNoDalog,
    hoverCopy,
    createQualityList,
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      userList: [],
      activeName: "all",
      filters: {
        DateType: "tf.CreateTime",
      },
      dateTypeOptions: [
        {
          value: "tf.CreateTime",
          label: "创建时间",
        },
        {
          value: "tet.EstimatedDate",
          label: "预计送仓",
        },
        {
          value: "tet.ActualArriveDate",
          label: "实际到仓",
        },
        {
          value: "tet.CompleteReceiptDate",
          label: "完成收货",
        },
        {
          value: "tet.CompletePutOnDate",
          label: "完成上架",
        },
      ],
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          width: "120",
          options: [
            {
              prop: "resynchronize",
              name: "日志",
              size: "small",
              type: "text",
              slot: true,
            },
            // {
            //   name: "日志",
            //   size: "small",
            //   type: "text",
            //   event: "getbusinessLoglist", // 操作的事件名
            // },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "signForNumber",
            label: "收货单号",
            align: "center",
            slot: true,
            minWidth: "150",
          },
          {
            prop: "deliveryOrdeNo",
            label: "WMS进仓号",

            minWidth: "180",
          },
          {
            prop: "orgCustomerNo",
            label: "参考单号",

            minWidth: "150",
          },
          {
            prop: "customName",
            label: "客户货主",

            minWidth: "130",
          },
          {
            prop: "deliveryTypeText",
            label: "入库类型",
          },
          {
            prop: "warehouseName",
            label: "仓库",
          },
          {
            prop: "destinationTypeText",
            label: "目的地类型",

            minWidth: "120",
          },

          {
            prop: "destination",
            label: "目的地",
            minWidth: "200",
          },
          {
            prop: "signForStatusText",
            label: "收货状态",
          },
          {
            prop: "totalBoxCount",
            label: "预报箱数",
          },
          {
            prop: "actualBoxCount",
            label: "签收箱数",
          },
          {
            prop: "receivedBoxCount",
            label: "实收箱数",
          },
          {
            prop: "receivedBoxVolume",
            label: "实收体积",
          },
          {
            prop: "receivedBoxWeight",
            label: "实收重量",
          },
          {
            prop: "isUnloadText",
            label: "仓库卸货",
          },
          {
            prop: "inventoryStatusText",
            label: "上架状态",
          },

          {
            prop: "file",
            label: "附件",
            minWidth: "120",
            align: "left",
            slot: true,
          },
          {
            prop: "distributeGoodsMark",
            label: "分货码",
            slot: true,
            minWidth: "100",
          },
          {
            prop: "palletMark",
            label: "托唛",
            slot: true,
            minWidth: "100",
          },
          {
            prop: "operatorInfo",
            label: "操作人",
            slot: true,
            minWidth: "100",
          },
          {
            prop: "abnorInfo",
            label: "异常",
            minWidth: "120",
            align: "left",
            slot: true,
          },
          {
            prop: "date",
            label: "日期",
            align: "left",
            minWidth: "210",
            formatter: function (val, row) {
              var html =
                "创建时间：" +
                row.createTime +
                "<br/>" +
                "预计到仓：" +
                (row.estimatedDate || "") +
                "<br/>" +
                "实际到仓：" +
                (row.actualArriveDate || "") +
                "<br/>" +
                "完成收货：" +
                (row.completeReceiptDate || "") +
                "<br/>" +
                "完成上架：" +
                (row.completePutOnDate || "") +
                "<br/>";
              return html;
            },
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "key",
            label: "单据号",
            placeholder: "收货单号/WMS进仓号/参考单号",
            clearable: true,
          },

          {
            type: "select",
            key: "OrgId",
            prop: "OrgId",
            label: "客户货主",
            multiple: true,
            slot: true,
            placeholder: "请选择客户货主",
            option: this.organizationList,
          },
          {
            type: "select",
            key: "SignForStatus",
            prop: "SignForStatus",
            label: "收货状态",
            multiple: true,
            slot: true,
            placeholder: "请选择收货状态",
            option: this.signForStatusList,
          },
          {
            type: "select",
            key: "InventoryStatus",
            prop: "InventoryStatus",
            label: "上架状态",
            multiple: true,
            slot: true,
            placeholder: "请选择上架状态",
            option: this.inventoryStatusList,
          },
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "select",
            key: "WarehouseId",
            prop: "WarehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouses,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            hideLabel: true,
            label: "创建时间",
            hideLabel: true,
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
      },

      buttonList: [],

      //-------------

      warehouses: [],
      allKinds: {
        beReceivedCount: 0,
        goodsReceivedCount: 0,
      },
      inventoryStatusList: [], //上架状态
      signForStatusList: [], //签收状态
      organizationList: [], //客户货主
      proListVisible: false,
      srcList: [],
    };
  },
  methods: {
    showReceiptNo(rowData) {
      this.$refs.ReceiptNoRef.showDialog(rowData);
    },
    // 新增质检
    create() {
      // 收货完成才能创建
      const { rows } = this.selectRows;
      if (rows.length !== 1) {
        this.$message({
          message: "请勾选一条数据",
          type: "error",
        });
        return;
      }
      if (rows[0].signForStatus !== 20) {
        this.$message({
          message: "请选择[收货完成]单据",
          type: "error",
        });
        return;
      }
      this.$refs.createQualityListRef.showDalog(rows[0]);
    },
    handleClick(tab, event) {
      let searchDeep = JSON.parse(JSON.stringify(this.searchData.moreSearch));
      searchDeep.forEach((item) => {
        if (item.key == "SignForStatus" && this.activeName !== "all") {
          item.hide = true;
        } else {
          item.hide = false;
        }
      });
      this.filters.SignForStatus = [];
      if (this.activeName !== "all") {
        var arr = [this.activeName * 1];
        this.$set(this.filters, "SignForStatus", arr);
      }
      // this.$set(this.newfilters,JSON.stringify(this.filters));
      this.newfilters = JSON.parse(JSON.stringify(this.filters));
      this.$set(this.searchData, "moreSearch", searchDeep);
      this.initTable();
    },
    callFunction(item) {
      if (item.name.trim() === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        //this.$set(this.newfilters,JSON.stringify(this.filters));
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        console.log(this.newfilters);
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    // 收货按钮
    receiptFunc() {
      const { rows } = this.selectRows;
      if (rows.length !== 1) {
        this.$message({
          message: "请勾选一条数据",
          type: "error",
        });
        return;
      }
      if (rows[0].signForStatus !== 10) {
        this.$message({
          message: "请选择[待收货]单据",
          type: "error",
        });
        return;
      }

      this.$router.push({
        path: "/Transfer/TFSignFor/SignInScanning",
        query: {
          signForNumber: rows[0].signForNumber,
        },
      });
    },
    resetBtn() {
      this.filters = {
        DateType: "tf.CreateTime",
      };
      this.$set(this.filters, "status", []);
    },

    //查询列表
    initTable() {
      const {
        WarehouseId,
        key,
        OrgId,
        InventoryStatus,
        SignForStatus,
        realName,
        tdate,
        DateType,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        key,
        WarehouseIDs: thereAre(WarehouseId),
        OrgIds: thereAre(OrgId),
        realName: thereAre(realName),
        InventoryStatus: thereAre(InventoryStatus),
        SignForStatus: thereAre(SignForStatus),
        DateType,
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getTFSignForTaskAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
        if (this.tableData.length > 0) {
          this.allKinds.beReceivedCount = this.tableData[0].beReceivedCount;
          this.allKinds.goodsReceivedCount =
            this.tableData[0].goodsReceivedCount;
        } else {
          this.allKinds.beReceivedCount = 0;
          this.allKinds.goodsReceivedCount = 0;
        }
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let TFSignForIDs = row.map((item) => item.tfSignForID).join(",");
      const {
        WarehouseIDs,
        key,
        OrgId,
        InventoryStatus,
        SignForStatus,
        tdate,
        DateType,
      } = this.newfilters;
      let para = {
        page: 1,
        pageSize: 60001,
        key,
        WarehouseIDs: thereAre(WarehouseIDs),
        OrgIds: thereAre(OrgId),
        InventoryStatus: thereAre(InventoryStatus),
        SignForStatus: thereAre(SignForStatus),
        TFSignForIDs,
        DateType,
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportSignForTaskAsyncOut,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    inited(viewer) {
      this.$viewer = viewer;
    },
    //预览图片
    getReadyImages(id, type) {
      const data = {
        sourceID: id,
        sourceType: type,
      };
      //this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getUploadFileInfoBySourceID(data).then((res) => {
        loading.close();
        if (res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
    //下载照片
    handleImages(id, signForNumber, type) {
      const para = {
        sourceID: id,
        sourceType: type,
        title: "收货" + signForNumber,
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(getUploadFileReviewImagesFileOut, {
          params: para,
        })
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //下载分货码
    DownloadAttachBtn(file) {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      window.open(file.fileUrlF, "_blank");

      loading.close();
    },
    //下载托唛
    DownloadProductSKUAttachBtn(file) {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      window.open(file.fileUrl, "_blank");

      loading.close();
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;
    getSignForTaskBasis("").then((res) => {
      this.organizationList = res.data.response.organizationList;
      this.inventoryStatusList = res.data.response.tfInventoryStatusList;
      this.signForStatusList = res.data.response.tfSignForStatusList;
    });
  },
};
</script>

<style scoped>
.dateSelect {
  width: 130px;
  margin-right: 12px;
}
</style>